export default class CartItem {
  id;
  product;
  quantity;
  pricelist;
  options;
  duty;
  margin;
  notes;
  shipping;
  overridePrice;
  effectivePrice;
  isConfig;
  clientOnly;
  loading;

  //Absence of Product
  sku;
  image;

  constructor(itemWire, person, productBySku, imageByNameLowerCase) {
    if (itemWire) {
      this.id = itemWire.Prp_Itm_Dto_Id;
      this.sku = itemWire.Prp_Itm_Dto_Sku;
      this.product = productBySku[itemWire.Prp_Itm_Dto_Sku];
      this.image = this.product ? this.product.photoSet.individual : imageByNameLowerCase["amptab_default.jpg"];
      this.quantity = itemWire.Prp_Itm_Dto_Quantity;
      this.pricelist = itemWire.Prp_Itm_Dto_Pricelist;
      this.options = itemWire.Prp_Itm_Dto_Options;
      this.duty = itemWire.Prp_Itm_Dto_Duty;
      this.margin = itemWire.Prp_Itm_Dto_Margin;
      this.notes = itemWire.Prp_Itm_Dto_Notes;
      this.overridePrice = itemWire.Prp_Itm_Dto_OverridePrice;
      this.effectivePrice = itemWire.Prp_Itm_Dto_UnitPrice;
      this.shipping = itemWire.Prp_Itm_Dto_Shipping;
      this.isConfig = itemWire.Prp_Itm_Dto_IsConfigureable;
      this.clientOnly = false;
      this.loading = false;
    }
    else if (person) {
      this.id = person.itemId;
      this.sku = person.sku;
      this.product = productBySku[person.sku];
      this.image = this.product.photoSet.individual;
      this.quantity = person.quantity;
      this.pricelist = null;
      this.options = null;
      this.duty = null;
      this.margin = null;
      this.notes = null;
      this.overridePrice = null;
      this.effectivePrice = null;
      this.shipping = null;
      this.isConfig = null;
      this.clientOnly = true;
      this.loading = true;
    }
  }
}
